/*
  Price per serving, the OPT-IN line: see snippets/price-per-serving-shown.liquid. Loaded only by
  that snippet, so only where the main-product setting pps_follow_shown_price is on (Supreme).

  The line ("80 g tin · about 50¢ a cup, or 42¢ on subscription.") divides the prices the page SHOWS
  (Supreme Matcha update, PR #208, 2026-10-02):
  1. one-time: while assets/promo-price.js shows the promo block ([data-promo-price], not hidden:
     inside the sale window and no selling plan selected), the promo price for the selected variant
     (the "cents" map in [data-promo-pdp]); otherwise the variant price.
  2. subscription: the selected selling plan's allocation price; before a plan is selected, the
     first plan's. A selected plan this product has no price for hides the clause.
  3. RULE (pps_sub_only_when_lower, data-pps-sub-rule="lower", default on; reversible): the
     subscription clause shows only when its figure is LOWER than the one-time figure.
  4. A variant with no servings, no price, or a figure that rounds to 0 cents hides the whole line.
     It never prints NaN, Infinity, 0 or a negative figure.
  5. Unit: under 100 cents "50¢"; 100 cents or more "$1.10". Half a cent rounds up (Math.round).
  6. The pack size ("80 g tin") and the label ("a cup", the variant's own, else the product's)
     belong to each variant; switching variants switches both.
  The arithmetic is in perServing / figures / formatCents / subShown, exported for
  scripts/test-price-per-serving.mjs. Everything below boot() is DOM glue.
*/
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && !window.__harneyPpsBooted) {
    window.__harneyPpsBooted = true;
    window.HarneyPricePerServing = api;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { api.boot(document); });
    } else {
      api.boot(document);
    }
  }
})(function () {
  'use strict';

  var has = Object.prototype.hasOwnProperty;

  var isCount = function (value) {
    return typeof value === 'number' && isFinite(value) && value > 0;
  };

  // Whole cents per serving, nearest cent, half up; null when it cannot be computed or rounds to 0.
  var perServing = function (cents, servings) {
    if (!isCount(cents) || !isCount(servings)) { return null; }
    var result = Math.round(cents / servings);
    return result > 0 ? result : null;
  };

  // "50¢" under a dollar, "$1.10" from 100 cents.
  var formatCents = function (cents) {
    if (cents >= 100) {
      var rest = cents % 100;
      return '$' + Math.floor(cents / 100) + '.' + (rest < 10 ? '0' : '') + rest;
    }
    return cents + '¢';
  };

  // entry: { servings, price, size, firstPlan, plans: { planId: cents } } from the snippet's map.
  // view:  { promoShown, promoCents, planId } read from the page.
  // Returns { one, sub } in cents (sub may be null), or null to hide the line.
  var figures = function (entry, view) {
    if (!entry) { return null; }
    view = view || {};
    var oneCents = entry.price;
    if (view.promoShown && isCount(view.promoCents)) { oneCents = view.promoCents; }
    var one = perServing(oneCents, entry.servings);
    if (one === null) { return null; }

    var subCents = null;
    var plan = view.planId ? String(view.planId) : '';
    if (plan) {
      if (entry.plans && has.call(entry.plans, plan)) { subCents = entry.plans[plan]; }
    } else if (isCount(entry.firstPlan)) {
      subCents = entry.firstPlan;
    }
    return { one: one, sub: subCents === null ? null : perServing(subCents, entry.servings) };
  };

  // The RULE: with onlyWhenLower, the clause shows only when the subscription figure is lower.
  var subShown = function (result, onlyWhenLower) {
    if (!result || result.sub === null) { return false; }
    return onlyWhenLower ? result.sub < result.one : true;
  };

  var parse = function (node) {
    if (!node) { return null; }
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  };

  // The same reads assets/promo-price.js makes, so both scripts agree on what is shown.
  var readView = function (root, promoCents) {
    var meta = root.closest('product-meta');
    var form = meta && document.getElementById(meta.getAttribute('form-id'));
    var plan = form && form.querySelector('[name="selling_plan"]');
    var priceList = meta && meta.querySelector('[data-product-price-list]');
    var promo = priceList && priceList.querySelector('[data-promo-price]');
    var variantId = root.getAttribute('data-pps-variant');
    return {
      variantId: variantId,
      planId: plan && plan.value ? String(plan.value) : '',
      promoShown: !!(promo && !promo.hidden),
      promoCents: promoCents && variantId && has.call(promoCents, variantId) ? promoCents[variantId] : null
    };
  };

  var render = function (root, entry, result) {
    if (!result) { root.hidden = true; return; }
    var lead = root.querySelector('[data-pps-lead]');
    var label = root.querySelector('[data-pps-label]');
    var one = root.querySelector('[data-pps-one]');
    var sub = root.querySelector('[data-pps-sub]');
    var clause = root.querySelector('[data-pps-sub-clause]');
    if (lead) { lead.textContent = entry && entry.size ? entry.size + ' · about' : 'About'; }
    if (label && entry && entry.label) { label.textContent = entry.label; }
    if (one) { one.textContent = formatCents(result.one); }
    var showSub = subShown(result, root.getAttribute('data-pps-sub-rule') === 'lower');
    if (clause) {
      clause.hidden = !showSub;
      if (sub && showSub) { sub.textContent = formatCents(result.sub); }
    }
    root.hidden = false;
  };

  var watch = function (root) {
    if (root.ppsWatched) { return; }
    root.ppsWatched = true;
    var map = parse(document.getElementById(root.id + '-map')) || {};
    var meta = root.closest('product-meta');
    var form = meta && document.getElementById(meta.getAttribute('form-id'));
    var priceList = meta && meta.querySelector('[data-product-price-list]');
    // Read once: theme.js replaces the price list's children on variant change.
    var promoData = parse(priceList && priceList.querySelector('[data-promo-pdp]'));
    var promoCents = promoData && promoData.cents ? promoData.cents : null;

    var update = function () {
      var view = readView(root, promoCents);
      if (!has.call(map, view.variantId)) { return; }
      var entry = map[view.variantId];
      render(root, entry, figures(entry, view));
    };
    var later = function () { setTimeout(update, 60); setTimeout(update, 400); };

    if (form) {
      form.addEventListener('variant:changed', function (event) {
        var variant = event && event.detail && event.detail.variant;
        if (!variant) { return; }
        root.setAttribute('data-pps-variant', String(variant.id));
        later();
      });
    }
    // promo-price.js shows and hides the promo block by toggling [hidden]; follow it.
    if (priceList) {
      new MutationObserver(update).observe(priceList, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    // Loop sets selling_plan without a reliable event (promo-price.js re-checks after 50 ms).
    ['click', 'change'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (event.target.closest && event.target.closest('.loop-widget-container, product-form, form[action*="/cart/add"]')) { later(); }
      }, true);
    });
    setInterval(update, 30000);
    update();
  };

  // Only the opt-in line's roots (they carry data-pps-sub-rule); the default snippet's line, if it
  // is on the same page, keeps its own inline script and is never touched here.
  var boot = function (doc) {
    (doc || document).querySelectorAll('[data-price-per-serving][data-pps-sub-rule]').forEach(watch);
  };

  return { perServing: perServing, formatCents: formatCents, figures: figures, subShown: subShown, readView: readView, render: render, boot: boot };
});
